/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import "reflect-metadata";
import "./index.css";

import { App } from "./src/App";

console.log = () => {};
console.warn = () => {};
console.info = () => {};
console.error = () => {};

// updated env to production

export default App;
